import { Vertical } from 'component/Vertical'
import { observer } from 'mobx-react-lite'
import { SizeLabel } from 'page/ProfileScreen/SizeSlider/SizeLabel'
import { SizeRange } from 'page/ProfileScreen/SizeSlider/SizeRange'
import { SizeSlider } from 'page/ProfileScreen/SizeSlider/SizeSlider'

type Props = {
  min: number
  max: number
  value: number
  label: string
  plus?: boolean
  onChange(value: number): void
}

export const SizePane = observer(({ min, max, value, label, plus, onChange }: Props) => {
  return <Vertical>
    <SizeLabel label={label} value={value} plus={plus} />
    <SizeSlider min={min} max={max} value={value} onChange={onChange} />
    <SizeRange min={min} max={max} plus={plus} />
  </Vertical>
})
